import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const undesiredForesightRoutes = [
  {
    path: "/directories/undesired-foresight",
    name: "UndesiredForesightList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "undesiredForesight" */ "./components/List"),
  },
];
